export default __webpack_public_path__ + "static/sangbleukingdom-lightitalic-webfont-e7a46129bc4f204f26b9622e5e078686.woff";